import React from 'react'
import { Radar } from '@nivo/radar'
import { COLORS } from '../Reports'

const theme = {
  axis: {
    ticks: {
      text: {
        fontSize: 12,
      }
    },
  },
  dots: {
    text: {
      fontSize: 14,
    }
  },
};

const RadarChart = ({ data }) => {
  return (
    <Radar
      data={data}
      keys={['Self', 'Supervisors', 'Peers', 'Direct']}
      indexBy="competency"
      width={784}
      height={512}
      colors={COLORS}
      maxValue="auto"
      fillOpacity={0}
      margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
      blendMode="normal"
      gridLevels={4}
      gridShape="circular"
      curve="linearClosed"
      borderWidth={2}
      borderColor={{ from: 'color' }}
      gridLabelOffset={36}
      animate
      motionStiffness={90}
      motionDamping={15}
      isInteractive
      theme={theme}
      legends={[
        {
          anchor: 'top-left',
          direction: 'column',
          translateX: -50,
          translateY: -40,
          itemWidth: 80,
          itemHeight: 20,
          itemTextColor: '#999',
          symbolSize: 12,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}

    />
  )
}

export default RadarChart
